export default __webpack_public_path__ + "static/media/kms_dejados_de_recorrer.e0c4e124.png";